import { personalInfo } from "../data/mock";
import SeoHead from "../components/SeoHead";

const PrivacyPolicy = () => {
  return (
    <div>
      <SeoHead
        title="Privacy Policy | Abhilash Puljal"
        description="How Abhilash Puljal handles personal information collected through this website — contact form submissions, profile download requests, and analytics."
        path="/privacy"
      />
      <section className="py-20 bg-[#FAF8F4]">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <p className="text-xs tracking-[0.3em] uppercase text-[#B8945A] font-sans mb-4">Legal</p>
          <h1 className="font-serif text-4xl md:text-5xl font-bold text-[#1C2B3A] mb-4">Privacy Policy</h1>
          <div className="w-20 h-[2px] bg-[#B8945A]"></div>
          <p className="font-sans text-sm text-[#7A7A7A] mt-6">Last updated: July 2025</p>
        </div>
      </section>
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-6 md:px-12 font-sans text-[#4A4A4A] leading-[1.85] space-y-10">
          <div>
            <h2 className="font-serif text-2xl font-bold text-[#1C2B3A] mb-4">1. Introduction</h2>
            <p>This Privacy Policy explains how Abhilash Puljal ("we," "us," or "our") collects, uses, and protects your personal data when you visit our website. This policy is compliant with the European Union's General Data Protection Regulation (GDPR), India's Digital Personal Data Protection Act, 2023 (DPDP Act), and other applicable data protection laws.</p>
          </div>
          <div>
            <h2 className="font-serif text-2xl font-bold text-[#1C2B3A] mb-4">2. Data We Collect</h2>
            <p className="mb-3">We may collect the following personal data:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Contact Information:</strong> Name and email address when you submit the contact form or request a profile download.</li>
              <li><strong>Usage Data:</strong> Information about how you interact with our website, including pages visited, time spent, and browser type.</li>
              <li><strong>Cookies:</strong> Essential cookies for site functionality and optional analytics cookies (with your consent).</li>
            </ul>
          </div>
          <div>
            <h2 className="font-serif text-2xl font-bold text-[#1C2B3A] mb-4">3. Purpose of Data Collection</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>To respond to your enquiries and messages.</li>
              <li>To provide requested documents (profile downloads).</li>
              <li>To improve our website experience through analytics (with consent).</li>
              <li>To maintain website security and functionality.</li>
            </ul>
          </div>
          <div>
            <h2 className="font-serif text-2xl font-bold text-[#1C2B3A] mb-4">4. Legal Basis for Processing (GDPR)</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Consent:</strong> For analytics cookies and marketing communications.</li>
              <li><strong>Legitimate Interest:</strong> For responding to enquiries and maintaining site security.</li>
              <li><strong>Contractual Necessity:</strong> When processing data to fulfill your requests.</li>
            </ul>
          </div>
          <div>
            <h2 className="font-serif text-2xl font-bold text-[#1C2B3A] mb-4">5. Compliance with India's DPDP Act, 2023</h2>
            <p>In accordance with the Digital Personal Data Protection Act, 2023 of India, we ensure that:</p>
            <ul className="list-disc pl-6 space-y-2 mt-3">
              <li>Personal data is processed only for lawful purposes with your consent.</li>
              <li>Data is collected only to the extent necessary for the stated purpose.</li>
              <li>You have the right to access, correct, and erase your personal data.</li>
              <li>We implement reasonable security safeguards to protect your data.</li>
              <li>Data is retained only as long as necessary for the purpose of collection.</li>
            </ul>
          </div>
          <div>
            <h2 className="font-serif text-2xl font-bold text-[#1C2B3A] mb-4">6. Cookies</h2>
            <p className="mb-3">We use the following types of cookies:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Essential Cookies:</strong> Required for basic website functionality. These cannot be disabled.</li>
              <li><strong>Analytics Cookies:</strong> Help us understand how visitors interact with the website. These are only activated with your consent.</li>
            </ul>
            <p className="mt-3">You can manage your cookie preferences at any time through your browser settings or by clearing your cookie consent from this website.</p>
          </div>
          <div>
            <h2 className="font-serif text-2xl font-bold text-[#1C2B3A] mb-4">7. Your Rights</h2>
            <p className="mb-3">Under GDPR and the DPDP Act, you have the right to:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Access the personal data we hold about you.</li>
              <li>Request correction of inaccurate personal data.</li>
              <li>Request deletion of your personal data.</li>
              <li>Withdraw consent at any time.</li>
              <li>Lodge a complaint with a supervisory authority.</li>
              <li>Nominate another person to exercise your rights (DPDP Act).</li>
            </ul>
          </div>
          <div>
            <h2 className="font-serif text-2xl font-bold text-[#1C2B3A] mb-4">8. Data Retention</h2>
            <p>We retain personal data only as long as necessary to fulfill the purposes for which it was collected. Contact form submissions and download requests are retained for a maximum of 24 months unless otherwise required by law.</p>
          </div>
          <div>
            <h2 className="font-serif text-2xl font-bold text-[#1C2B3A] mb-4">9. Third-Party Sharing</h2>
            <p>We do not sell, trade, or otherwise transfer your personal data to third parties. We may share data with trusted service providers who assist us in operating our website, provided they agree to keep this information confidential.</p>
          </div>
          <div>
            <h2 className="font-serif text-2xl font-bold text-[#1C2B3A] mb-4">10. Contact</h2>
            <p>For any questions regarding this Privacy Policy or to exercise your data rights, please contact:</p>
            <p className="mt-3"><strong>Abhilash Puljal</strong><br />Email: {personalInfo.contact.email}<br />Address: {personalInfo.contact.address}</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;